
(function () {
  if (window.OSHKA_LIVE_RUNTIME_HOTFIX_20260618_V68) return;
  window.OSHKA_LIVE_RUNTIME_HOTFIX_20260618_V68 = true;

  // Shopify's product form requires this Dawn helper. Restore it when another
  // theme customization has removed it so add-to-cart cannot remain loading.
  if (typeof window.fetchConfig !== 'function') {
    window.fetchConfig = function (type) {
      type = type || 'json';
      return {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/' + type
        }
      };
    };
  }

  // Newer Dawn product forms call these optional performance helpers. Keep
  // cart behavior functional when the corresponding theme asset is missing.
  if (typeof window.CartPerformance !== 'object') {
    window.CartPerformance = {
      createStartingMarker: function () { return null; },
      measureFromMarker: function () {},
      measure: function (name, callback) { return typeof callback === 'function' ? callback() : undefined; },
      measureFromEvent: function () {}
    };
  }

  if (typeof window.onKeyUpEscape !== 'function') {
    window.onKeyUpEscape = function (event) {
      if (event && event.code !== 'Escape') return;
      var openDetails = event && event.target && event.target.closest && event.target.closest('details[open]');
      if (openDetails) openDetails.removeAttribute('open');
    };
  }

  function important(el, prop, value) {
    if (el) el.style.setProperty(prop, value, 'important');
  }

  function isHebrew() {
    var stored = '';
    try { stored = (localStorage.getItem('oshka-language-choice') || '').toLowerCase(); } catch (e) {}
    if (stored.indexOf('en') === 0) return false;
    if (stored.indexOf('he') === 0 || stored.indexOf('iw') === 0) return true;
    var lang = (document.documentElement.lang || '').toLowerCase();
    if (lang.indexOf('he') === 0 || lang.indexOf('iw') === 0 || location.pathname.indexOf('/he') === 0) return true;
    var bodyText = String(document.body && document.body.innerText || '').slice(0, 1200);
    return bodyText.indexOf('עגלה') > -1 || bodyText.indexOf('קולקצ') > -1 || bodyText.indexOf('משלוח') > -1;
  }

  function isHebrew() {
    var path = (location.pathname || '').toLowerCase();
    if (path === '/en' || path.indexOf('/en/') === 0) return false;
    if (path === '/he' || path.indexOf('/he/') === 0) return true;
    var stored = '';
    try { stored = (localStorage.getItem('oshka-language-choice') || '').toLowerCase(); } catch (e) {}
    if (stored.indexOf('en') === 0) return false;
    if (stored.indexOf('he') === 0 || stored.indexOf('iw') === 0) return true;
    var lang = (document.documentElement.lang || '').toLowerCase();
    return lang.indexOf('he') === 0 || lang.indexOf('iw') === 0 || path.indexOf('/he') === 0 || path === '/';
  }

  function fixBrokenLocaleUrls() {
    if (location.pathname.indexOf('/he/') === 0 && /404|Page not found/i.test(document.body && document.body.innerText || '')) {
      location.replace(location.pathname.slice(3) + location.search + location.hash);
      return;
    }
    document.querySelectorAll('a[href^="/he/collections"], a[href^="/he/products"], a[href="/he/"]').forEach(function (link) {
      var href = link.getAttribute('href') || '';
      link.setAttribute('href', href === '/he/' ? '/' : href.slice(3));
    });
  }

  function updateShippingCopy() {
    var bar = document.querySelector('.announcement-bar__message, .announcement-bar');
    if (bar) {
      var text = isHebrew()
        ? 'קולקציית אביב/קיץ 2026 | משלוח בתוספת ₪35 | איסוף עצמי ללא עלות מהחנות'
        : 'NEW IN - Spring/Summer 2026 Collection | SHIPPING FEE ₪35 | FREE SELF PICKUP IN STORE';
      var target = bar.querySelector('span') || bar;
      if (String(target.textContent || '').trim() !== text) target.textContent = text;
    }
  }

  function normalizeProductMicrocopy() {
    if (location.pathname.indexOf('/products/') === -1 && location.pathname.indexOf('/he/products/') === -1) return;
    var he = isHebrew();
    document.querySelectorAll('main h1, .product__title h1, .product__info-container h1').forEach(function (heading) {
      important(heading, 'font-family', 'Jost, Arial, Helvetica, sans-serif');
      important(heading, 'letter-spacing', '0');
      important(heading, 'text-transform', 'uppercase');
    });
    document.querySelectorAll('.product__tax, .product__tax.caption, .product__tax.caption.rte').forEach(function (element) {
      element.textContent = he ? 'משלוח בתוספת 35₪ או איסוף עצמי ללא עלות.' : 'Shipping fee ₪35 or free self pickup in store.';
    });
    if (!he) return;
    document.querySelectorAll('.pickup-availability-info .caption-large, pickup-availability-preview .caption-large').forEach(function (element) {
      if ((element.textContent || '').indexOf('Pickup available at') > -1) element.textContent = 'איסוף עצמי זמין בחנות OSHKA';
    });
    document.querySelectorAll('.pickup-availability-info .caption, pickup-availability-preview .caption').forEach(function (element) {
      if ((element.textContent || '').indexOf('Usually ready') > -1) element.textContent = 'בדרך כלל מוכן תוך 24 שעות';
    });
    document.querySelectorAll('.pickup-availability-preview.caption-large, .pickup-availability-list__item .pickup-availability-preview').forEach(function (element) {
      if ((element.textContent || '').indexOf('Pickup available') > -1) element.textContent = 'איסוף עצמי זמין, בדרך כלל מוכן תוך 24 שעות';
    });
  }

  function normalizeCartMicrocopy() {
    if (location.pathname.indexOf('/cart') === -1 && location.pathname.indexOf('/he/cart') === -1) return;
    var cartText = String(document.body && document.body.innerText || '');
    var he = isHebrew() || /[֐-׿]/.test(cartText);
    var replacements = he ? {
      'Your cart': 'העגלה שלך',
      'Continue shopping': 'המשך קנייה',
      'PRODUCT': 'מוצר',
      'Product': 'מוצר',
      'TOTAL': 'סה"כ',
      'Total': 'סה"כ',
      'Estimated total': 'סה"כ משוער',
      'Check out': 'לתשלום',
      'Loading...': ''
    } : {
      'העגלה שלך': 'Your cart',
      'המשך קנייה': 'Continue shopping',
      'מוצר': 'PRODUCT',
      'סה"כ': 'TOTAL',
      'סה"כ משוער': 'Estimated total',
      'לתשלום': 'Check out'
    };
    document.querySelectorAll('h1, h2, h3, a, button, th, caption, .title, .cart__warnings, .totals__total, .cart__ctas button, .underlined-link').forEach(function (element) {
      var text = String(element.textContent || '').replace(new RegExp('\\s+', 'g'), ' ').trim();
      if (Object.prototype.hasOwnProperty.call(replacements, text)) element.textContent = replacements[text];
    });
    var root = document.querySelector('main') || document.body;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      var clean = String(node.nodeValue || '').replace(new RegExp('\\s+', 'g'), ' ').trim();
      if (Object.prototype.hasOwnProperty.call(replacements, clean)) {
        node.nodeValue = node.nodeValue.replace(clean, replacements[clean]);
      }
    }
    document.querySelectorAll('.tax-note, .cart__dynamic-checkout-buttons + small, .cart__footer .caption-large, .totals + small').forEach(function (element) {
      var text = String(element.textContent || '');
      if (text.indexOf('Taxes included') > -1 || text.indexOf('shipping calculated') > -1 || text.indexOf('הנחות') > -1) {
        element.textContent = he ? 'משלוח בתוספת 35₪ או איסוף עצמי ללא עלות יחושבו בקופה.' : 'Shipping fee ₪35 or free self pickup will be calculated at checkout.';
      }
    });
  }

  function forceHebrewCartLabels() {
    if (location.pathname.indexOf('/cart') === -1 && location.pathname.indexOf('/he/cart') === -1) return;
    var visibleText = String(document.body && document.body.innerText || '');
    if (visibleText.indexOf('עגלה') === -1 && visibleText.indexOf('משלוח') === -1 && visibleText.indexOf('לתשלום') === -1) return;
    var map = {
      'Continue shopping': 'המשך קנייה',
      'Estimated total': 'סה"כ משוער',
      'Your cart': 'העגלה שלך',
      'Product': 'מוצר',
      'PRODUCT': 'מוצר',
      'Total': 'סה"כ',
      'TOTAL': 'סה"כ',
      'Check out': 'לתשלום',
      'Taxes included. Discounts and shipping calculated at checkout.': 'משלוח בתוספת 35₪ או איסוף עצמי ללא עלות יחושבו בקופה.'
    };
    var walker = document.createTreeWalker(document.querySelector('main') || document.body, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      var clean = String(node.nodeValue || '').replace(new RegExp('\\s+', 'g'), ' ').trim();
      if (map[clean]) node.nodeValue = map[clean];
    }
  }

  function rememberLanguageChoice() {
    document.addEventListener('submit', function (event) {
      var form = event.target;
      var input = form && form.querySelector && form.querySelector('[name="locale_code"]');
      if (input && input.value) localStorage.setItem('oshka-language-choice', input.value);
    }, true);
  }

  function applyDefaultHebrew() {
    if (isHebrew() || window.Shopify && Shopify.designMode) return;
    if (localStorage.getItem('oshka-language-choice')) return;
    var path = location.pathname === '/' ? '/' : location.pathname;
    location.replace('/he' + path + location.search + location.hash);
  }

  function applyDefaultHebrew() {
    if (window.Shopify && Shopify.designMode) return;
    try {
      if (!localStorage.getItem('oshka-language-choice')) localStorage.setItem('oshka-language-choice', 'he');
    } catch (e) {}
    fixBrokenLocaleUrls();
  }

  function compactCookie() {
    document.querySelectorAll('.oshka-cookie-popup-fixed').forEach(function (popup) {
      var accepted = false;
      try { accepted = localStorage.getItem('oshka-cookie-consent') === 'accepted'; } catch (e) {}
      if (accepted) {
        popup.remove();
        return;
      }
      if (popup.dataset.oshkaCookieBound !== '1') {
        popup.dataset.oshkaCookieBound = '1';
        popup.addEventListener('click', function (event) {
          var target = event.target && event.target.closest && event.target.closest('.oshka-cookie-popup-fixed__accept, .oshka-cookie-popup-fixed__close, button, [role="button"]');
          if (!target) return;
          try { localStorage.setItem('oshka-cookie-consent', 'accepted'); } catch (e) {}
          popup.remove();
        }, true);
      }
      important(popup, 'box-sizing', 'border-box');
      important(popup, 'position', 'fixed');
      important(popup, 'left', '0');
      important(popup, 'right', '0');
      important(popup, 'bottom', '0');
      important(popup, 'width', '100%');
      important(popup, 'max-width', '100%');
      important(popup, 'max-height', '205px');
      important(popup, 'min-height', '0');
      important(popup, 'padding', '14px 28px 16px');
      important(popup, 'overflow-y', 'auto');
      important(popup, 'overflow-x', 'hidden');
      important(popup, 'z-index', '2147483646');
      var heading = popup.querySelector('h2');
      important(heading, 'font-family', 'Jost, Arial, Helvetica, sans-serif');
      important(heading, 'font-size', '18px');
      important(heading, 'line-height', '1.15');
      important(heading, 'margin', '0 0 8px');
      var paragraph = popup.querySelector('p');
      important(paragraph, 'font-family', 'Jost, Arial, Helvetica, sans-serif');
      important(paragraph, 'font-size', '12px');
      important(paragraph, 'line-height', '1.28');
      important(paragraph, 'margin', '0 auto 10px');
      important(paragraph, 'max-width', '340px');
      var accept = popup.querySelector('.oshka-cookie-popup-fixed__accept');
      important(accept, 'min-height', '36px');
      important(accept, 'padding', '6px 24px');
      important(accept, 'font-size', '14px');
      important(accept, 'margin', '0 auto');
      important(accept, 'display', 'inline-flex');
      important(accept, 'align-items', 'center');
      important(accept, 'justify-content', 'center');
      var close = popup.querySelector('.oshka-cookie-popup-fixed__close');
      important(close, 'top', '8px');
      important(close, 'right', '12px');
      important(close, 'font-size', '24px');
      important(close, 'line-height', '1');
    });
  }

  function translateAccount() {
    var text = isHebrew() ? '\u05D4\u05EA\u05D7\u05D1\u05E8\u05D5\u05EA / \u05D4\u05E8\u05E9\u05DE\u05D4' : 'Log in / Sign up';
    document.querySelectorAll('#menu-drawer .menu-drawer__account').forEach(function (link) {
      var current = link.querySelector('.oshka-stable-login-text');
      if (!current || link.querySelectorAll('.oshka-stable-login-text').length !== 1) {
        link.innerHTML = '<span class="oshka-stable-login-text"></span><svg class="oshka-stable-account-icon" viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="12" cy="7.5" r="3.5" stroke="currentColor" stroke-width="1.4"></circle><path d="M5.5 20c.5-4.1 2.8-6.2 6.5-6.2s6 2.1 6.5 6.2H5.5Z" stroke="currentColor" stroke-width="1.4"></path></svg>';
        current = link.querySelector('.oshka-stable-login-text');
      }
      if (current.textContent !== text) current.textContent = text;
      important(link, 'font-family', 'Jost, Arial, Helvetica, sans-serif');
      important(link, 'font-size', '18px');
      important(link, 'line-height', '1.18');
      important(link, 'white-space', 'nowrap');
    });
  }

  function normalizeMenu() {
    document.querySelectorAll(
      '#menu-drawer .menu-drawer__menu-item, #menu-drawer .menu-drawer__menu-item span, ' +
      '#menu-drawer .oshka-mobile-secondary-menu__link, #menu-drawer .menu-drawer__account, ' +
      '#menu-drawer .localization-form__select, #menu-drawer .disclosure__button'
    ).forEach(function (el) {
      important(el, 'font-family', 'Jost, Arial, Helvetica, sans-serif');
      important(el, 'font-size', '18px');
      important(el, 'line-height', '1.18');
      important(el, 'font-weight', '400');
      important(el, 'letter-spacing', '0');
      important(el, 'text-transform', 'uppercase');
    });
  }

  function normalizeMenuStructure() {
    var labels = {
      '#HeaderDrawer-home': 'HOME',
      '#HeaderDrawer-collection': 'COLLECTION',
      '#HeaderDrawer-sale': 'SALE',
      '#HeaderDrawer-sale-first-layer': 'SALE'
    };
    Object.keys(labels).forEach(function (selector) {
      document.querySelectorAll('#menu-drawer ' + selector).forEach(function (item) {
        var textNode = Array.prototype.find.call(item.childNodes, function (node) {
          return node.nodeType === Node.TEXT_NODE && node.textContent.trim();
        });
        if (textNode) textNode.textContent = labels[selector];
        else {
          var span = item.querySelector('span');
          if (span) span.textContent = labels[selector];
        }
      });
    });

    var collection = document.querySelector('#menu-drawer #HeaderDrawer-collection');
    var details = collection && collection.closest('details');
    var submenu = details && details.querySelector('.menu-drawer__inner-submenu > ul.menu-drawer__menu');
    if (submenu) {
      submenu.innerHTML =
        '<li><a id="HeaderDrawer-collection-new-in" href="/collections/new-in" class="menu-drawer__menu-item link link--text list-menu__item focus-inset">New In</a></li>' +
        '<li><a id="HeaderDrawer-collection-best-sellers" href="/collections/best-sellers" class="menu-drawer__menu-item link link--text list-menu__item focus-inset">Best Sellers</a></li>' +
        '<li><a id="HeaderDrawer-collection-ruya" href="/collections/ruya" class="menu-drawer__menu-item link link--text list-menu__item focus-inset">Rüya</a></li>';
    }
  }

  function fixViewportHeaderAndFonts() {
    if (!document.getElementById('oshka-runtime-polish-v29-style')) {
      var style = document.createElement('style');
      style.id = 'oshka-runtime-polish-v29-style';
      style.textContent =
        'html,body{max-width:100%!important;overflow-x:hidden!important;}' +
        'body,button,input,select,textarea,.card__heading,.price,.product-card-wrapper .card__heading,.collection-hero__title{font-family:Jost,Arial,Helvetica,sans-serif!important;letter-spacing:0!important;}' +
        '@media(max-width:749px){.header-wrapper .header{height:104px!important;min-height:104px!important;}.header-wrapper{height:105px!important;min-height:105px!important;}}' +
        '#menu-drawer{width:100vw!important;max-width:100vw!important;overflow:hidden!important;}' +
        '#menu-drawer,#menu-drawer *{direction:ltr!important;text-align:left!important;}' +
        '#menu-drawer .menu-drawer__inner-container{width:100%!important;max-width:100%!important;height:100%!important;overflow-x:hidden!important;overflow-y:auto!important;-webkit-overflow-scrolling:touch!important;}' +
        '#menu-drawer .menu-drawer__navigation-container{display:block!important;height:auto!important;min-height:100%!important;overflow:visible!important;}' +
        '#menu-drawer .menu-drawer__navigation{width:100%!important;max-width:100%!important;height:270px!important;min-height:0!important;overflow:visible!important;padding-bottom:0!important;}' +
        '#menu-drawer .menu-drawer__menu,#menu-drawer .oshka-mobile-secondary-menu{padding-left:24px!important;padding-right:24px!important;box-sizing:border-box!important;}' +
        '#menu-drawer #oshka-primary-menu-v29{background:#fff!important;padding-bottom:24px!important;margin-bottom:0!important;height:auto!important;overflow:visible!important;}' +
        '#menu-drawer .menu-drawer__utility-links{position:static!important;height:auto!important;min-height:0!important;margin-top:0!important;overflow:visible!important;padding-bottom:32px!important;}' +
        '#menu-drawer .oshka-mobile-secondary-menu{height:auto!important;min-height:0!important;overflow:visible!important;}' +
        '#menu-drawer details>.menu-drawer__submenu{position:static!important;transform:none!important;width:100%!important;height:auto!important;overflow:visible!important;background:#fff!important;}' +
        '#menu-drawer details:not([open])>.menu-drawer__submenu{display:none!important;}' +
        '#menu-drawer details[open]>.menu-drawer__submenu{display:block!important;visibility:visible!important;}' +
        '#menu-drawer details>.menu-drawer__submenu>.menu-drawer__menu{position:static!important;transform:none!important;width:100%!important;height:auto!important;padding:0 0 8px 18px!important;overflow:visible!important;}' +
        '#menu-drawer .menu-drawer__menu-item,#menu-drawer .oshka-mobile-secondary-menu__link,#menu-drawer .menu-drawer__account{font-family:Jost,Arial,Helvetica,sans-serif!important;font-size:18px!important;line-height:1.18!important;font-weight:400!important;letter-spacing:0!important;text-transform:uppercase!important;}' +
        '#menu-drawer .menu-drawer__menu-item,#menu-drawer summary.menu-drawer__menu-item{justify-content:flex-start!important;gap:10px!important;}' +
        '#menu-drawer summary.menu-drawer__menu-item span[aria-hidden="true"]{margin-left:auto!important;margin-right:0!important;}' +
        '#menu-drawer .menu-drawer__account{display:inline-flex!important;align-items:center!important;gap:10px!important;max-width:100%!important;white-space:nowrap!important;}' +
        '#menu-drawer .list-social__link,#menu-drawer .list-social__link *,footer .list-social__link,footer .list-social__link *{text-decoration:none!important;border-bottom:0!important;box-shadow:none!important;}' +
        '#menu-drawer .oshka-mobile-social .oshka-ms-link,#menu-drawer .oshka-mobile-social a{display:inline-flex!important;align-items:center!important;justify-content:center!important;width:22px!important;height:42px!important;padding:0!important;border:0!important;border-radius:0!important;outline:0!important;box-shadow:none!important;text-decoration:none!important;background:transparent!important;color:#fff!important;}' +
        '#menu-drawer .oshka-mobile-social .oshka-ms-link svg,#menu-drawer .oshka-mobile-social .oshka-ms-link svg *{border:0!important;outline:0!important;box-shadow:none!important;}' +
        '#menu-drawer a[href*="wa.me"],#menu-drawer a[href*="whatsapp"]{display:inline-flex!important;align-items:center!important;justify-content:center!important;width:22px!important;height:42px!important;padding:0!important;border:0!important;text-decoration:none!important;box-shadow:none!important;color:#fff!important;background:transparent!important;border-radius:0!important;}' +
        '#menu-drawer a[href*="wa.me"] svg,#menu-drawer a[href*="whatsapp"] svg{display:block!important;width:22px!important;height:22px!important;stroke:#fff!important;fill:none!important;}' +
        '@media screen and (max-width:749px){.product-grid .card__inner,.collection .card__inner{--ratio-percent:125%!important;aspect-ratio:4/5!important;width:100%!important;height:auto!important;overflow:hidden!important;}.product-grid .card__inner.ratio:before,.collection .card__inner.ratio:before{padding-bottom:125%!important;}.product-grid .card__media,.product-grid .card__media .media,.collection .card__media,.collection .card__media .media{position:absolute!important;inset:0!important;width:100%!important;height:100%!important;padding-bottom:0!important;overflow:hidden!important;}.product-grid .card__media img,.collection .card__media img{width:100%!important;height:100%!important;object-fit:cover!important;object-position:center center!important;}}' +
        '.oshka-custom-search-results{position:absolute!important;top:100%!important;left:0!important;right:0!important;background:#fff!important;z-index:20!important;max-height:min(62vh,520px)!important;overflow-y:auto!important;border-top:1px solid rgba(0,0,0,.12)!important;padding:8px 14px 14px!important;box-shadow:0 10px 24px rgba(0,0,0,.1)!important;}' +
        '.oshka-custom-search-results[hidden]{display:none!important;}' +
        '.oshka-custom-search-item{display:grid!important;grid-template-columns:64px minmax(0,1fr)!important;gap:12px!important;align-items:center!important;padding:10px 0!important;color:#111!important;text-decoration:none!important;border-bottom:1px solid rgba(0,0,0,.09)!important;pointer-events:auto!important;}' +
        '.oshka-custom-search-item img{width:64px!important;height:82px!important;object-fit:cover!important;display:block!important;}' +
        '.oshka-custom-search-item__title{display:block!important;font:500 14px/1.3 Jost,Arial,sans-serif!important;color:#111!important;}' +
        '.oshka-custom-search-item__price{display:block!important;font:400 13px/1.3 Jost,Arial,sans-serif!important;color:#555!important;margin-top:4px!important;}' +
        'predictive-search .predictive-search-status{display:none!important;}' +
        '.oshka-custom-search-empty{padding:18px 4px!important;font:400 14px/1.4 Jost,Arial,sans-serif!important;color:#555!important;}' +
        '.header{position:relative!important;}' +
        '.header>.header__heading,.header>.header__heading-link{position:absolute!important;left:50%!important;top:50%!important;width:140px!important;height:auto!important;min-width:0!important;min-height:0!important;margin:0!important;padding:0!important;transform:translate(-50%,-50%)!important;text-align:center!important;z-index:2!important;}' +
        '.header>.header__heading .header__heading-link{position:static!important;display:flex!important;width:140px!important;height:auto!important;min-width:0!important;min-height:0!important;padding:0!important;transform:none!important;align-items:center!important;justify-content:center!important;}' +
        '.header .header__heading-logo-wrapper.oshka-uploaded-logo-wrapper{width:140px!important;height:auto!important;min-width:0!important;min-height:0!important;max-width:140px!important;max-height:none!important;display:flex!important;align-items:center!important;justify-content:center!important;}' +
        '.header .header__heading-logo.oshka-uploaded-logo{width:140px!important;height:auto!important;min-width:0!important;min-height:0!important;max-width:140px!important;max-height:none!important;object-fit:contain!important;transform:none!important;margin:0!important;}' +
        'body.overflow-hidden-tablet .oshka-wa-float{display:none!important;}' +
        'main h1,.product__title,.product__title h1,.product__info-container .product__title,.product__info-container h1{font-family:Jost,Arial,Helvetica,sans-serif!important;letter-spacing:0!important;text-transform:uppercase!important;}' +
        'main variant-selects{display:block!important;width:100%!important;}' +
        'main variant-selects fieldset.product-form__input{display:flex!important;flex-wrap:wrap!important;align-items:center!important;justify-content:center!important;gap:10px!important;width:100%!important;max-width:100%!important;margin:0 auto 18px!important;padding:0!important;}' +
        'main variant-selects fieldset.product-form__input>legend{display:block!important;width:100%!important;margin:0 0 8px!important;text-align:center!important;}' +
        'main variant-selects fieldset.product-form__input--pill:not(:first-child) label{display:inline-flex!important;align-items:center!important;justify-content:center!important;min-width:52px!important;min-height:44px!important;margin:0!important;padding:8px 14px!important;}' +
        '.g-variant-color .swatches-options,.g-variant-color-detail .select-option{width:24px!important;height:24px!important;min-width:24px!important;min-height:24px!important;margin-inline-end:14px!important;overflow:visible!important;}' +
        '.card__swatches{display:flex!important;align-items:center!important;gap:10px!important;min-height:26px!important;padding:6px 0 2px!important;overflow:visible!important;}' +
        '.g-variant-color label.swatch-anchor,.g-variant-color-detail label.swatch-anchor,.card__swatch-dot{box-sizing:border-box!important;overflow:hidden!important;background-clip:padding-box!important;}' +
        '.card__swatch-dot[style*="url"],.card__swatch-dot[style*="image"],.oshka-related-style-swatches{display:none!important;}';
      (document.head || document.documentElement).appendChild(style);
    }
  }

  function ensureMenuCategories() {
    var drawer = document.querySelector('#menu-drawer');
    if (!drawer) return;
    var nav = drawer.querySelector('.menu-drawer__navigation');
    if (!nav) return;
    var old = drawer.querySelector('#oshka-primary-menu-v29');
    var menuHtml =
      '<li><a id="HeaderDrawer-home" href="/he/" class="menu-drawer__menu-item link link--text list-menu__item focus-inset">HOME</a></li>' +
      '<li><details><summary id="HeaderDrawer-collection" class="menu-drawer__menu-item list-menu__item link link--text focus-inset">COLLECTION <span aria-hidden="true">→</span></summary><div class="menu-drawer__submenu"><ul class="menu-drawer__menu list-menu" role="list">' +
      '<li><a href="/he/collections/new-in" class="menu-drawer__menu-item link link--text list-menu__item focus-inset">New In</a></li>' +
      '<li><a href="/he/collections/best-sellers" class="menu-drawer__menu-item link link--text list-menu__item focus-inset">Best Sellers</a></li>' +
      '<li><a href="/he/collections/ruya" class="menu-drawer__menu-item link link--text list-menu__item focus-inset">Rüya</a></li>' +
      '</ul></div></details></li>' +
      '<li><a id="HeaderDrawer-sale" href="/he/collections/sale" class="menu-drawer__menu-item link link--text list-menu__item focus-inset">SALE</a></li>';
    if (!old) {
      var firstList = nav.querySelector('ul.menu-drawer__menu');
      var block = document.createElement('ul');
      block.id = 'oshka-primary-menu-v29';
      block.className = 'menu-drawer__menu list-menu';
      block.innerHTML =
        '<li><a id="HeaderDrawer-home" href="/he/" class="menu-drawer__menu-item link link--text list-menu__item focus-inset">HOME</a></li>' +
        '<li><details><summary id="HeaderDrawer-collection" class="menu-drawer__menu-item list-menu__item link link--text focus-inset">COLLECTION <span aria-hidden="true">→</span></summary><div class="menu-drawer__submenu"><ul class="menu-drawer__menu list-menu" role="list">' +
        '<li><a href="/he/collections/new-in" class="menu-drawer__menu-item link link--text list-menu__item focus-inset">New In</a></li>' +
        '<li><a href="/he/collections/best-sellers" class="menu-drawer__menu-item link link--text list-menu__item focus-inset">Best Sellers</a></li>' +
        '<li><a href="/he/collections/ruya" class="menu-drawer__menu-item link link--text list-menu__item focus-inset">Rüya</a></li>' +
        '</ul></div></details></li>' +
        '<li><a id="HeaderDrawer-sale" href="/he/collections/sale" class="menu-drawer__menu-item link link--text list-menu__item focus-inset">SALE</a></li>';
      block.innerHTML = menuHtml;
      if (firstList) nav.insertBefore(block, firstList);
      else nav.insertBefore(block, nav.firstChild);
      drawer.querySelectorAll('#HeaderDrawer-home, #HeaderDrawer-collection, #HeaderDrawer-sale, #HeaderDrawer-sale-first-layer').forEach(function (item) {
        if (!item.closest('#oshka-primary-menu-v29')) {
          var li = item.closest('li');
          if (li) li.remove();
        }
      });
    } else if (!old.querySelector('#HeaderDrawer-collection') || !old.textContent.includes('Best Sellers') || !old.textContent.includes('Rüya')) {
      old.innerHTML = menuHtml;
    }
    drawer.querySelectorAll('a, summary').forEach(function (item) {
      var text = String(item.textContent || '').replace(new RegExp('\\s+', 'g'), ' ').trim();
      if (text === 'מבצע' || text === 'סייל') item.textContent = 'SALE';
      if (text === 'שאלות נפוצות') item.textContent = 'FAQ';
    });
    var secondaryLabels = [
      [new RegExp('/pages/store(?:$|[?#])|/pages/store-1(?:$|[?#])'), 'STORE'],
      [new RegExp('/pages/contact(?:$|[?#])'), 'CONTACT US'],
      [new RegExp('/pages/about-us(?:$|[?#])'), 'ABOUT US'],
      [new RegExp('/pages/faq(?:$|[?#])'), 'FAQ'],
      [new RegExp('/products/gift-card|/pages/gift-card'), 'GIFT CARD']
    ];
    drawer.querySelectorAll('a[href]').forEach(function (link) {
      var href = link.getAttribute('href') || '';
      secondaryLabels.some(function (pair) {
        if (pair[0].test(href)) {
          link.textContent = pair[1];
          return true;
        }
        return false;
      });
    });
  }

  function normalizeSocialLinks() {
    var whatsappSvg = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 11.5a8 8 0 0 1-11.9 7L4 20l1.4-4.2A8 8 0 1 1 20 11.5Z"></path><path d="M8.6 8.3c.2-.4.4-.4.7-.4h.5c.2 0 .4 0 .6.5l.8 1.9c.1.2.1.4 0 .6-.2.3-.4.5-.6.8-.1.1-.2.3-.1.5.4.8 1 1.5 1.7 2 .8.6 1.4.8 1.6.9.2.1.4 0 .5-.1l.8-1c.2-.2.4-.2.6-.1l1.9.9c.3.1.4.3.4.5 0 .5-.4 1.5-1 1.9-.6.4-1.4.5-2.3.3-2-.4-4.1-1.7-5.7-3.3-1.5-1.5-2.7-3.6-3-5.1-.1-.8 0-1.5.4-2 .3-.4.8-.7 1.2-.7Z"></path></svg>';
    document.querySelectorAll('#menu-drawer .list-social__link, footer .list-social__link, #menu-drawer .list-social a, footer .list-social a').forEach(function (link) {
      important(link, 'text-decoration', 'none');
      important(link, 'border-bottom', '0');
      important(link, 'box-shadow', 'none');
      link.querySelectorAll('*').forEach(function (child) {
        important(child, 'text-decoration', 'none');
        important(child, 'border-bottom', '0');
        important(child, 'box-shadow', 'none');
      });
    });
    document.querySelectorAll('#menu-drawer .oshka-mobile-social .oshka-ms-link, #menu-drawer .oshka-mobile-social a').forEach(function (link) {
      important(link, 'border', '0');
      important(link, 'border-top', '0');
      important(link, 'border-right', '0');
      important(link, 'border-bottom', '0');
      important(link, 'border-left', '0');
      important(link, 'outline', '0');
      important(link, 'box-shadow', 'none');
      important(link, 'background', 'transparent');
    });
    document.querySelectorAll('#menu-drawer .list-social, footer .list-social').forEach(function (list) {
      var existing = Array.from(list.querySelectorAll('a[href*="wa.me"], a[href*="whatsapp"]'));
      existing.slice(1).forEach(function (link) {
        var item = link.closest('li');
        if (item) item.remove(); else link.remove();
      });
      var link = existing[0];
      if (!link) {
        var li = document.createElement('li');
        li.className = 'list-social__item oshka-social-whatsapp';
        link = document.createElement('a');
        link.className = 'list-social__link link';
        li.appendChild(link);
        list.appendChild(li);
      }
      link.href = 'https://wa.me/message/LG2CVB43ID2NE1';
      link.target = '_blank';
      link.rel = 'noopener';
      link.setAttribute('aria-label', 'WhatsApp');
      link.innerHTML = whatsappSvg;
    });
    document.querySelectorAll('#menu-drawer .oshka-mobile-social, .menu-drawer .oshka-mobile-social').forEach(function (list) {
      var links = Array.from(list.querySelectorAll('a[href*="wa.me"], a[href*="whatsapp"]'));
      links.slice(1).forEach(function (duplicate) { duplicate.remove(); });
      var link = links[0] || document.createElement('a');
      link.href = 'https://wa.me/message/LG2CVB43ID2NE1';
      link.className = 'oshka-ms-link oshka-ms-whatsapp';
      link.target = '_blank';
      link.rel = 'noopener';
      link.setAttribute('aria-label', 'WhatsApp');
      link.innerHTML = whatsappSvg;
      if (!link.parentNode) list.appendChild(link);
    });
  }

  function normalizeFindMySizeText() {
    var wanted = isHebrew() ? 'מצאי את המידה שלך' : 'Find My Size';
    document.querySelectorAll('a, button, summary, .oshka-size-helper-trigger').forEach(function (element) {
      var text = String(element.textContent || '').replace(new RegExp('\\s+', 'g'), ' ').trim().toLowerCase();
      if (text === 'find my size' || text === 'מצאי את המידה שלי' || text === 'מצאי את המידה שלך' || text === 'מצאי מידה') {
        element.textContent = wanted;
      }
    });
    document.querySelectorAll('.find-my-size-link').forEach(function (legacyLink) {
      if (document.querySelector('.oshka-size-helper-trigger')) legacyLink.style.setProperty('display', 'none', 'important');
    });
  }

  function normalizeLooseHeadings() {
    var map = isHebrew() ? {
      'You may also like': 'אולי תאהבי גם',
      'Customer Reviews': 'ביקורות לקוחות',
      'Be the first to write a review': 'היי הראשונה לכתוב ביקורת',
      'היה הראשון לכתוב ביקורת': 'היי הראשונה לכתוב ביקורת',
      'Contact form': 'טופס יצירת קשר',
      'Find My Size': 'מצאי את המידה שלך'
    } : {
      'אולי תאהבי גם': 'You may also like',
      'ביקורות לקוחות': 'Customer Reviews',
      'היי הראשונה לכתוב ביקורת': 'Be the first to write a review',
      'טופס יצירת קשר': 'Contact form',
      'מצאי את המידה שלך': 'Find My Size'
    };
    document.querySelectorAll('h1,h2,h3,h4,p,a,button,span').forEach(function (element) {
      if (element.children.length > 2) return;
      var text = String(element.textContent || '').replace(new RegExp('\\s+', 'g'), ' ').trim();
      if (map[text]) element.textContent = map[text];
    });
  }

  var searchProductsPromise;
  function installProductSearch() {
    function normalizedQuery(value) {
      var query = String(value || '').trim().toLowerCase();
      var mappings = [
        [new RegExp('\u05e9\u05de\u05dc'), 'dress'],
        [new RegExp('\u05d7\u05dc\u05d9\u05e4'), 'suit'],
        [new RegExp('\u05d7\u05e6\u05d0\u05d9\u05ea'), 'skirt'],
        [new RegExp('\u05d7\u05d2\u05d5\u05e8'), 'belt'],
        [new RegExp('\u05de\u05d7\u05d5\u05da'), 'corset'],
        [new RegExp('\u05d8\u05d5\u05e4|\u05d7\u05d5\u05dc\u05e6'), 'top']
      ];
      for (var i = 0; i < mappings.length; i += 1) {
        if (mappings[i][0].test(query)) return mappings[i][1];
      }
      return query;
    }
    function escapeHtml(value) {
      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
    }
    function productSearchData() {
      if (!searchProductsPromise) {
        searchProductsPromise = fetch('/products.json?limit=250', { headers: { Accept: 'application/json' } })
          .then(function (response) { return response.ok ? response.json() : { products: [] }; })
          .then(function (data) { return data.products || []; })
          .catch(function () { return []; });
      }
      return searchProductsPromise;
    }
    document.querySelectorAll('form.search-modal__form, predictive-search form.search').forEach(function (form) {
      if (form.dataset.oshkaProductSearch === 'true') return;
      var input = form.querySelector('input[type="search"], input[name="q"]');
      if (!input) return;
      var cleanInput = input.cloneNode(true);
      cleanInput.dataset.oshkaDetachedSearch = 'true';
      input.replaceWith(cleanInput);
      input = cleanInput;
      form.dataset.oshkaProductSearch = 'true';
      important(form, 'position', 'relative');
      form.querySelectorAll('.predictive-search, [id*="predictive-search-results"]').forEach(function (nativeResults) {
        important(nativeResults, 'display', 'none');
      });
      var results = document.createElement('div');
      results.className = 'oshka-custom-search-results';
      results.hidden = true;
      results.setAttribute('role', 'listbox');
      form.appendChild(results);
      var timer;
      input.addEventListener('input', function () {
        clearTimeout(timer);
        var original = String(input.value || '').trim();
        if (!original) {
          results.hidden = true;
          results.innerHTML = '';
          return;
        }
        timer = setTimeout(function () {
          var query = normalizedQuery(original);
          productSearchData().then(function (products) {
            var matches = products.filter(function (product) {
              var haystack = [
                product.title,
                product.product_type,
                Array.isArray(product.tags) ? product.tags.join(' ') : product.tags,
                product.body_html
              ].join(' ').toLowerCase();
              return haystack.indexOf(query) > -1 || haystack.indexOf(original.toLowerCase()) > -1;
            }).slice(0, 8);
            if (!matches.length) {
              results.innerHTML = '<div class="oshka-custom-search-empty">' +
                (isHebrew() ? 'לא נמצאו מוצרים' : 'No products found') +
                '</div>';
              results.hidden = false;
              return;
            }
            results.innerHTML = matches.map(function (product) {
              var image = product.images && product.images[0] && product.images[0].src || '';
              var prices = (product.variants || []).map(function (variant) { return Number(variant.price || 0); }).filter(function (price) { return price > 0; });
              var price = prices.length ? Math.min.apply(Math, prices).toFixed(2) : '';
              return '<a class="oshka-custom-search-item" role="option" href="/products/' + encodeURIComponent(product.handle) + '">' +
                (image ? '<img src="' + escapeHtml(image) + '" alt="" loading="lazy">' : '<span></span>') +
                '<span><span class="oshka-custom-search-item__title">' + escapeHtml(product.title) + '</span>' +
                (price ? '<span class="oshka-custom-search-item__price">₪' + escapeHtml(price) + '</span>' : '') +
                '</span></a>';
            }).join('');
            results.hidden = false;
          });
        }, 180);
      });
      input.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') results.hidden = true;
      });
    });
  }

  function normalizeSearchAndCheckoutRoutes() {
    var isHe = isHebrew();
    function mapSearchTerm(value) {
      var v = String(value || '').trim();
      var map = [
        [/שמל(ה|ות)/i, 'dress'],
        [/חליפ(ה|ות)/i, 'suit'],
        [/חצאית/i, 'skirt'],
        [/חגור/i, 'belt'],
        [/מחוך/i, 'corset'],
        [/טופ|חולצ/i, 'top']
      ];
      for (var i = 0; i < map.length; i += 1) {
        if (map[i][0].test(v)) return map[i][1];
      }
      return v;
    }
    if (location.pathname.indexOf('/search') !== -1) {
      var params = new URLSearchParams(location.search);
      var currentQuery = params.get('q') || '';
      var mappedQuery = mapSearchTerm(currentQuery);
      if (mappedQuery && mappedQuery !== currentQuery && params.get('oshka_search_mapped') !== '1') {
        params.set('q', mappedQuery);
        params.set('oshka_search_mapped', '1');
        location.replace(location.pathname + '?' + params.toString() + location.hash);
        return;
      }
    }
    document.querySelectorAll('form[action*="/search"], form[action="/he/search"], form[action="/search"]').forEach(function (form) {
      if (form.dataset.oshkaSearchMapped) return;
      form.dataset.oshkaSearchMapped = 'true';
      form.addEventListener('submit', function () {
        var q = form.querySelector('[name="q"]');
        if (!q) return;
        q.value = mapSearchTerm(q.value);
      }, { capture: true });
    });
    document.querySelectorAll('form[action*="/checkout"], a[href*="/checkout"], button[name="checkout"]').forEach(function (element) {
      if (element.tagName === 'FORM') {
        if (isHe) element.action = '/checkout?locale=he-IL';
      } else if (element.tagName === 'A') {
        if (isHe) element.setAttribute('href', '/checkout?locale=he-IL');
      }
    });
  }

  function normalizeHomeStoryCopy() {
    var path = String(location.pathname || '') || '/';
    if (path === '/he') path = '/';
    else if (path.indexOf('/he/') === 0) path = path.slice(3) || '/';
    if (path !== '/') return;
    var he = isHebrew();
    var heTitle = 'הסטייל שלך, הסיפור שלנו';
    var enTitle = 'Your Style, Our Story';
    var heBody = 'אנחנו מאמינות שאופנה היא הרבה מעבר לבגד - היא ביטוי אישי ותחושה אמיתית. כל פריט של OSHKA נבחר באהבה עבור האישה המודרנית.';
    var enBody = 'We believe fashion is more than clothing - it is self-expression and authentic feeling. Every Oshka piece is carefully selected with love for the modern woman.';
    document.querySelectorAll('h1,h2,h3').forEach(function (element) {
      var text = String(element.textContent || '').replace(new RegExp('\\s+', 'g'), ' ').trim();
      if (text === heTitle || text === enTitle) element.textContent = he ? heTitle : enTitle;
    });
    document.querySelectorAll('p').forEach(function (element) {
      var text = String(element.textContent || '').replace(new RegExp('\\s+', 'g'), ' ').trim();
      if (text.indexOf('We believe fashion is more than clothing') === 0 || text.indexOf('אנחנו מאמינות שאופנה') === 0) {
        element.textContent = he ? heBody : enBody;
      }
    });
  }

  function normalizeStaticPageCopy() {
    var path = String(location.pathname || '').toLowerCase();
    var isFaq = path.indexOf('/pages/faq') !== -1;
    var isStore = path.indexOf('/pages/store') !== -1;
    if (!isFaq && !isStore) return;
    var rte = document.querySelector('main .rte');
    if (!rte || rte.dataset.oshkaStaticCopyFixed === 'true') return;
    rte.dataset.oshkaStaticCopyFixed = 'true';
    var he = isHebrew();
    if (isFaq) {
      rte.innerHTML = he ? [
        '<h3>משלוחים</h3>',
        '<p><strong>כמה זמן לוקח משלוח?</strong><br>משלוחים מגיעים בדרך כלל תוך 1-14 ימי עסקים. בתקופות עומס, השקות או חגים ייתכנו עיכובים קלים.</p>',
        '<p><strong>מה עלות המשלוח?</strong><br>משלוח עד הבית בעלות קבועה של 35 ש"ח.</p>',
        '<p><strong>האם אפשר איסוף עצמי?</strong><br>כן. ניתן לבחור איסוף עצמי ללא עלות מהחנות: הציונות 4, קריית היובל, ירושלים.</p>',
        '<h3>החזרות והחלפות</h3>',
        '<p>ניתן לבצע החזרה או החלפה עד 14 ימים מקבלת ההזמנה, בהתאם למדיניות ההחזרות וההחלפות של OSHKA. הפריט חייב להיות חדש, לא בשימוש, לא מכובס, ללא פגם ועם הטיקט/האריזה המקוריים.</p>',
        '<p>לפני החזרה או החלפה יש ליצור איתנו קשר כדי שנוכל לאשר את הבקשה ולהנחות אותך בתהליך.</p>',
        '<p><a href="https://wa.me/message/LG2CVB43ID2NE1" target="_blank" rel="noopener">יצירת קשר בוואטסאפ</a></p>',
        '<h3>תשלום</h3>',
        '<p>אנחנו מקבלות תשלומים מאובטחים באמצעי התשלום שמופיעים בצ׳קאאוט. נכון לעכשיו אין תשלום דרך PayPal.</p>',
        '<h3>יצירת קשר</h3>',
        '<p>אימייל: officialoshka@gmail.com<br>וואטסאפ: <a href="https://wa.me/message/LG2CVB43ID2NE1" target="_blank" rel="noopener">OSHKA WhatsApp</a></p>'
      ].join('') : [
        '<h3>Shipping</h3>',
        '<p><strong>How long does shipping take?</strong><br>Orders usually arrive within 1-14 business days. During launches, holidays, or high-volume periods, slight delays may occur.</p>',
        '<p><strong>How much does shipping cost?</strong><br>Home delivery has a fixed fee of ₪35.</p>',
        '<p><strong>Can I choose self pickup?</strong><br>Yes. Free self pickup is available from our store: HaTziyonut 4, Kiryat HaYovel, Jerusalem.</p>',
        '<h3>Returns & Exchanges</h3>',
        '<p>Returns or exchanges are available within 14 days of receiving the order, according to the OSHKA returns and exchanges policy. Items must be new, unused, unwashed, undamaged, and with original tags/packaging.</p>',
        '<p>Before returning or exchanging an item, please contact us so we can approve the request and guide you through the process.</p>',
        '<p><a href="https://wa.me/message/LG2CVB43ID2NE1" target="_blank" rel="noopener">Contact us on WhatsApp</a></p>',
        '<h3>Payment</h3>',
        '<p>We accept secure payments through the payment methods shown at checkout. PayPal is currently not available.</p>',
        '<h3>Contact</h3>',
        '<p>Email: officialoshka@gmail.com<br>WhatsApp: <a href="https://wa.me/message/LG2CVB43ID2NE1" target="_blank" rel="noopener">OSHKA WhatsApp</a></p>'
      ].join('');
    }
    if (isStore) {
      rte.innerHTML = he ? [
        '<p><strong>כתובת:</strong> הציונות 4, קריית היובל, ירושלים</p>',
        '<p><strong>איסוף עצמי:</strong> ניתן לבחור איסוף עצמי ללא עלות מהחנות.</p>',
        '<p><a href="https://maps.app.goo.gl/UbLPJAv8fjX51aBZ6?g_st=ic" target="_blank" rel="noopener">ניווט לחנות</a></p>',
        '<p><a href="https://wa.me/message/LG2CVB43ID2NE1" target="_blank" rel="noopener">תיאום הגעה בוואטסאפ</a></p>'
      ].join('') : [
        '<p><strong>Address:</strong> HaTziyonut 4, Kiryat HaYovel, Jerusalem</p>',
        '<p><strong>Self pickup:</strong> Free self pickup is available from our store.</p>',
        '<p><a href="https://maps.app.goo.gl/UbLPJAv8fjX51aBZ6?g_st=ic" target="_blank" rel="noopener">Navigate to the store</a></p>',
        '<p><a href="https://wa.me/message/LG2CVB43ID2NE1" target="_blank" rel="noopener">Schedule arrival on WhatsApp</a></p>'
      ].join('');
    }
  }

  function normalizeBag() {
    document.querySelectorAll('svg.oshka-clean-bag-icon').forEach(function (bag) {
      important(bag, 'width', '29px');
      important(bag, 'height', '29px');
      var paths = bag.querySelectorAll('path');
      if (paths[0]) paths[0].setAttribute('d', 'M18 27H46V52H18V27Z');
      if (paths[1]) paths[1].setAttribute('d', 'M24 30V20C24 13.4 27.6 9 32 9C36.4 9 40 13.4 40 20V30');
      paths.forEach(function (path) {
        path.setAttribute('stroke-width', '1.8');
        important(path, 'stroke-width', '1.8px');
        important(path, 'vector-effect', 'non-scaling-stroke');
      });
    });
  }

  function normalizeCardBags() {
    document.querySelectorAll('.card__bag-icon').forEach(function (link) {
      important(link, 'width', '38px');
      important(link, 'height', '38px');
      important(link, 'top', '12px');
      important(link, 'right', '12px');
      var bag = link.querySelector('svg');
      if (!bag) return;
      bag.setAttribute('viewBox', '0 0 64 64');
      bag.setAttribute('width', '28');
      bag.setAttribute('height', '28');
      important(bag, 'width', '28px');
      important(bag, 'height', '28px');
      important(bag, 'overflow', 'visible');
      var paths = bag.querySelectorAll('path');
      if (paths[0]) paths[0].setAttribute('d', 'M18 27H46V52H18V27Z');
      if (paths[1]) paths[1].setAttribute('d', 'M24 30V20C24 13.4 27.6 9 32 9C36.4 9 40 13.4 40 20V30');
      paths.forEach(function (path) {
        path.setAttribute('stroke-width', '1.7');
        important(path, 'stroke-width', '1.7px');
        important(path, 'vector-effect', 'non-scaling-stroke');
      });
    });
  }

  var collarStylesPromise;
  function renderRelatedStyleSwatches() {
    document.querySelectorAll('.oshka-related-style-swatches').forEach(function (wrapper) {
      wrapper.remove();
    });
  }

  function swatchColor(value) {
    var rawValue = String(value || '').replace(/Variant sold out or unavailable/gi, '').trim().toLowerCase();
    if (rawValue.indexOf('black') > -1 || rawValue.indexOf('\u05e9\u05d7\u05d5\u05e8') > -1) return '#000000';
    if (rawValue.indexOf('white') > -1 || rawValue.indexOf('ivory') > -1 || rawValue.indexOf('\u05dc\u05d1\u05df') > -1 || rawValue.indexOf('\u05ea\u05d7\u05e8\u05d4') > -1) return '#f7f5ef';
    if (rawValue.indexOf('cream') > -1 || rawValue.indexOf('\u05e9\u05de\u05e0\u05ea') > -1) return '#efe6d7';
    if (rawValue.indexOf('wine') > -1 || rawValue.indexOf('burgundy') > -1 || rawValue.indexOf('\u05d1\u05d5\u05e8\u05d3\u05d5') > -1 || rawValue.indexOf('\u05d9\u05d9\u05df') > -1) return '#8b1024';
    if (rawValue.indexOf('chocolate') > -1 || rawValue.indexOf('\u05e9\u05d5\u05e7\u05d5\u05dc\u05d3') > -1) return '#442117';
    if (rawValue.indexOf('reddish') > -1 || rawValue.indexOf('\u05d0\u05d3\u05de\u05d3\u05dd') > -1) return '#7a2d1d';
    if (rawValue.indexOf('dark teal') > -1 || rawValue.indexOf('\u05d8\u05d5\u05e8\u05e7\u05d9\u05d6 \u05db\u05d4\u05d4') > -1) return '#064f4f';
    if (rawValue.indexOf('teal') > -1 || rawValue.indexOf('\u05d8\u05d5\u05e8\u05e7\u05d9\u05d6') > -1) return '#0d6762';
    if (rawValue.indexOf('stone') > -1 || rawValue.indexOf('\u05d0\u05d1\u05df') > -1) return '#bcb3a6';
    if (rawValue.indexOf('beige') > -1 || rawValue.indexOf('\u05d1\u05d6') > -1) return '#c8baa7';
    if (rawValue.indexOf('brown') > -1 || rawValue.indexOf('\u05d7\u05d5\u05dd') > -1) return '#7a3f22';
    var colors = {
      'white': '#f7f5ef',
      'off white': '#f7f5ef',
      'ivory': '#f4efe4',
      'cream': '#efe6d7',
      'black': '#000000',
      'black (silver buckle)': '#000000',
      'שחור': '#000000',
      'שחור (אבזם כסף)': '#000000',
      'לבן': '#f7f5ef',
      'תחרה לבנה': '#f7f5ef',
      'שמנת': '#efe6d7',
      'wine red': '#8b1024',
      'burgundy': '#8b1024',
      'בורדו': '#8b1024',
      'יין': '#8b1024',
      'אדום יין': '#8b1024',
      'brown': '#7a3f22',
      'brown (gold buckle)': '#7a3f22',
      'חום': '#7a3f22',
      'חום (אבזם זהב)': '#7a3f22',
      'chocolate brown': '#442117',
      'חום שוקולד': '#442117',
      'dark brown': '#321812',
      'reddish brown': '#7a2d1d',
      'חום אדמדם': '#7a2d1d',
      'stone': '#bcb3a6',
      'אבן': '#bcb3a6',
      'beige': '#c8baa7',
      'בז׳': '#c8baa7',
      'בז': '#c8baa7',
      'dark teal': '#064f4f',
      'טורקיז כהה': '#064f4f',
      'teal': '#0d6762',
      'טורקיז': '#0d6762'
    };
    return colors[rawValue] || '#d7d7d7';
  }

  function paintSwatches() {
    function cleanSwatchText(value) {
      return String(value || '')
        .replace(/Variant sold out or unavailable/gi, '')
        .replace(/\s+/g, ' ')
        .trim();
    }
    function swatchInputForLabel(label) {
      if (!label) return null;
      var input = label.htmlFor && document.getElementById(label.htmlFor);
      if (!input) input = label.querySelector('input[type="radio"]');
      if (!input) {
        var item = label.closest('.select-option, .swatches-options');
        input = item && item.querySelector('input[type="radio"]');
      }
      return input;
    }
    function isSizeLabel(label, value) {
      var text = cleanSwatchText(value).toLowerCase();
      if (!text) return true;
      if (/^(xxs|xs|s|m|l|xl|xxl|xxs-xxl|one size)$/i.test(text)) return true;
      var fieldset = label && label.closest && label.closest('fieldset');
      var legend = fieldset && fieldset.querySelector('legend');
      var legendText = cleanSwatchText(legend && legend.textContent).toLowerCase();
      if (legendText.indexOf('size') > -1 || legendText.indexOf('\u05de\u05d9\u05d3\u05d4') > -1) return true;
      if (legendText && legendText.indexOf('color') === -1 && legendText.indexOf('colour') === -1 && legendText.indexOf('\u05e6\u05d1\u05e2') === -1) return true;
      return false;
    }
    function styleSwatch(label, input, value, item) {
      var cleanValue = cleanSwatchText(value);
      if (!cleanValue || isSizeLabel(label, cleanValue)) return;
      var color = swatchColor(cleanValue);
      if (color === '#d7d7d7') return;
      if (item) important(item, '--oshka-swatch-color', color);
      important(label, '--oshka-swatch-color', color);
      important(label, 'background', color);
      important(label, 'background-color', color);
      important(label, 'background-image', 'none');
      important(label, 'width', '22px');
      important(label, 'height', '22px');
      important(label, 'min-width', '22px');
      important(label, 'min-height', '22px');
      important(label, 'max-width', '22px');
      important(label, 'max-height', '22px');
      important(label, 'padding', '0');
      important(label, 'overflow', 'hidden');
      important(label, 'border-radius', '50%');
      important(label, 'border', input && input.checked ? '2px solid #111' : '1px solid rgba(17,17,17,.35)');
      important(label, 'outline', '0');
      important(label, 'box-shadow', 'none');
      important(label, 'transform', 'none');
      important(label, 'transition', 'none');
      important(label, 'font-size', '0');
      label.setAttribute('aria-checked', input && input.checked ? 'true' : 'false');
    }
    document.querySelectorAll('.g-variant-color .swatches-options, .g-variant-color-detail .select-option').forEach(function (item) {
      var input = item.querySelector('input[type="radio"]');
      var label = item.querySelector('label.swatch-anchor');
      if (!label) return;
      var value = (input && input.value) || item.getAttribute('data-value') || label.getAttribute('title') || '';
      styleSwatch(label, input, value, item);
    });
    document.querySelectorAll('fieldset.product-form__input label, .product-form__input label').forEach(function (label) {
      var input = swatchInputForLabel(label);
      var value = (input && input.value) || label.getAttribute('title') || label.getAttribute('aria-label') || label.textContent || '';
      styleSwatch(label, input, value, label.closest('.product-form__input'));
    });
    document.querySelectorAll('fieldset.product-form__input').forEach(function (fieldset) {
      var legendText = String(fieldset.querySelector('legend') && fieldset.querySelector('legend').textContent || '').trim().toLowerCase();
      if (legendText.indexOf('color') === -1 && legendText.indexOf('colour') === -1 && legendText.indexOf('צבע') === -1) return;
      fieldset.querySelectorAll('input[type="radio"]').forEach(function (input) {
        var label = input.id && fieldset.querySelector('label[for="' + input.id + '"]');
        if (!label) return;
        styleSwatch(label, input, input.value || label.textContent || '', fieldset);
      });
    });
  }

  function paintCardSwatches() {
    document.querySelectorAll('.card__swatches').forEach(function (wrapper) {
      important(wrapper, 'display', 'flex');
      important(wrapper, 'align-items', 'center');
      important(wrapper, 'gap', '10px');
      important(wrapper, 'min-height', '26px');
      important(wrapper, 'padding', '6px 0 2px');
      important(wrapper, 'overflow', 'visible');
    });
    document.querySelectorAll('.card__swatch-dot').forEach(function (dot) {
      var value = dot.getAttribute('title') || dot.getAttribute('aria-label') || '';
      var color = swatchColor(value);
      important(dot, 'background', color);
      important(dot, 'background-color', color);
      important(dot, 'background-image', 'none');
      important(dot, 'width', '22px');
      important(dot, 'height', '22px');
      important(dot, 'min-width', '22px');
      important(dot, 'min-height', '22px');
      important(dot, 'max-width', '22px');
      important(dot, 'max-height', '22px');
      important(dot, 'border-radius', '50%');
      important(dot, 'transform', 'none');
      important(dot, 'transition', 'none');
    });
  }

  function restoreNativeVariantPicker() {
    if (location.pathname.indexOf('/products/') === -1 && location.pathname.indexOf('/he/products/') === -1) return;
    var appPicker = document.querySelector('.globo-swatch-product-detail, .g-variant-color-detail');
    var appPickerVisible = appPicker && appPicker.getBoundingClientRect().width > 0 && appPicker.getBoundingClientRect().height > 0;
    if (appPickerVisible) return;
    document.querySelectorAll('variant-selects').forEach(function (picker) {
      important(picker, 'display', 'block');
      important(picker, 'width', '100%');
      picker.querySelectorAll('fieldset.product-form__input').forEach(function (fieldset, fieldIndex) {
        important(fieldset, 'display', 'flex');
        important(fieldset, 'flex-wrap', 'wrap');
        important(fieldset, 'align-items', 'center');
        important(fieldset, 'justify-content', 'center');
        important(fieldset, 'gap', '10px');
        important(fieldset, 'width', '100%');
        important(fieldset, 'max-width', '100%');
        important(fieldset, 'margin', '0 auto 18px');
        important(fieldset, 'padding', '0');
        var legend = fieldset.querySelector('legend');
        important(legend, 'display', 'block');
        important(legend, 'width', '100%');
        important(legend, 'margin', '0 0 8px');
        important(legend, 'text-align', 'center');
        if (fieldIndex > 0) {
          fieldset.querySelectorAll('label').forEach(function (label) {
            important(label, 'display', 'inline-flex');
            important(label, 'align-items', 'center');
            important(label, 'justify-content', 'center');
            important(label, 'min-width', '52px');
            important(label, 'min-height', '44px');
            important(label, 'margin', '0');
            important(label, 'padding', '8px 14px');
          });
        }
      });
    });
  }

  function cleanCartPickupDuplicates() {
    document.querySelectorAll('.oshka-pickup-schedule-box').forEach(function (box) {
      box.remove();
    });
    var notes = Array.prototype.slice.call(document.querySelectorAll('.oshka-cart-shipping-note'));
    notes.forEach(function (note, index) {
      if (index > 0) note.remove();
    });
  }

  function hideBeltDressSizeHelper() {
    var path = String(location.pathname || '');
    if (path.indexOf('/he/') === 0) path = path.slice(3);
    if (path !== '/products/belt-dress' && path.indexOf('/products/belt-dress/') !== 0) return;
    document.documentElement.setAttribute('data-oshka-belt-dress', 'true');
    if (!document.getElementById('oshka-hide-belt-size-helper')) {
      var style = document.createElement('style');
      style.id = 'oshka-hide-belt-size-helper';
      style.textContent = '[data-oshka-belt-dress="true"] .oshka-size-helper-slot,[data-oshka-belt-dress="true"] .oshka-size-helper-trigger,[data-oshka-belt-dress="true"] .oshka-size-helper-overlay{display:none!important}';
      (document.head || document.documentElement).appendChild(style);
    }
    document.querySelectorAll('.oshka-size-helper-slot, .oshka-size-helper-trigger, .oshka-size-helper-overlay').forEach(function (element) {
      important(element, 'display', 'none');
    });
    document.querySelectorAll('a, button').forEach(function (element) {
      var text = String(element.textContent || '').replace(new RegExp('\\s+', 'g'), ' ').trim().toLowerCase();
      if (text === 'find my size' || text === 'מצאי את המידה שלי' || text === 'מצאי מידה') {
        important(element, 'display', 'none');
      }
    });
  }

  var productPromise;
  function currentSelectedOptions() {
    return Array.prototype.slice.call(document.querySelectorAll('fieldset.product-form__input, .product-form__input'))
      .map(function (group) {
        var checked = group.querySelector('input[type="radio"]:checked');
        return checked && checked.value;
      })
      .filter(Boolean);
  }
  function focusVariantImage(input) {
    if (!input || location.pathname.indexOf('/products/') !== 0) return;
    var item = input.closest('.select-option');
    var variantId = item && item.getAttribute('data-variantid');
    var productPath = location.pathname.indexOf('/he/products/') === 0 ? location.pathname.slice(3) : location.pathname;
    productPromise = productPromise || fetch(productPath + '.js', { headers: { Accept: 'application/json' } }).then(function (response) { return response.json(); });
    productPromise.then(function (product) {
      var selected = currentSelectedOptions();
      var variant = product.variants && product.variants.find(function (candidate) {
        if (variantId && String(candidate.id) === String(variantId)) return true;
        var options = candidate.options || [candidate.option1, candidate.option2, candidate.option3].filter(Boolean);
        return selected.length && selected.every(function (value, index) { return String(options[index] || '') === String(value || ''); });
      });
      var mediaId = variant && variant.featured_media && variant.featured_media.id;
      if (!mediaId && variant && variant.featured_image && variant.featured_image.src) {
        var activeMediaFallback = document.querySelector('.product__media-item.is-active') || document.querySelector('.product__media-item');
        var activeImageFallback = activeMediaFallback && activeMediaFallback.querySelector('img');
        if (activeImageFallback) {
          activeImageFallback.removeAttribute('srcset');
          activeImageFallback.src = variant.featured_image.src;
          activeImageFallback.alt = variant.featured_image.alt || activeImageFallback.alt || '';
        }
        return;
      }
      if (!mediaId) return;
      var media = document.querySelector('.product__media-item[data-media-id$="-' + mediaId + '"]');
      var imageUrl = variant.featured_media && variant.featured_media.preview_image && variant.featured_media.preview_image.src;
      if (!media && imageUrl) {
        var activeMedia = document.querySelector('.product__media-item.is-active') || document.querySelector('.product__media-item');
        var activeImage = activeMedia && activeMedia.querySelector('img');
        if (activeImage) {
          activeImage.removeAttribute('srcset');
          activeImage.src = imageUrl;
          activeImage.alt = variant.featured_media.alt || activeImage.alt || '';
          activeMedia.setAttribute('data-oshka-variant-media-id', String(mediaId));
        }
      }
      var gallery = media && media.closest('media-gallery');
      if (gallery && typeof gallery.setActiveMedia === 'function') {
        gallery.setActiveMedia(media.getAttribute('data-media-id'), true);
        return;
      }
      var thumbnail = document.querySelector('[data-target$="-' + mediaId + '"] button.thumbnail');
      if (media) {
        document.querySelectorAll('.product__media-item.is-active').forEach(function (item) { item.classList.remove('is-active'); });
        media.classList.add('is-active');
        var list = media.parentElement;
        if (list && typeof list.scrollTo === 'function') list.scrollTo({ left: media.offsetLeft, behavior: 'smooth' });
      }
      document.querySelectorAll('.thumbnail[aria-current="true"]').forEach(function (button) { button.removeAttribute('aria-current'); });
      if (thumbnail) {
        thumbnail.setAttribute('aria-current', 'true');
      }
    }).catch(function () {});
  }

  function run() {
    updateShippingCopy();
    normalizeProductMicrocopy();
    normalizeCartMicrocopy();
    forceHebrewCartLabels();
    fixBrokenLocaleUrls();
    compactCookie();
    translateAccount();
    fixViewportHeaderAndFonts();
    ensureMenuCategories();
    normalizeSocialLinks();
    normalizeFindMySizeText();
    normalizeLooseHeadings();
    installProductSearch();
    normalizeSearchAndCheckoutRoutes();
    normalizeHomeStoryCopy();
    normalizeStaticPageCopy();
    normalizeMenuStructure();
    normalizeMenu();
    normalizeBag();
    normalizeCardBags();
    renderRelatedStyleSwatches();
    restoreNativeVariantPicker();
    paintSwatches();
    paintCardSwatches();
    cleanCartPickupDuplicates();
    hideBeltDressSizeHelper();
  }

  rememberLanguageChoice();
  applyDefaultHebrew();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  window.addEventListener('load', run);
  if (location.pathname.indexOf('/cart') > -1 || location.pathname.indexOf('/he/cart') > -1) {
    [50, 250, 750, 1500, 3000, 6000, 10000].forEach(function (ms) {
      setTimeout(forceHebrewCartLabels, ms);
    });
  }
  document.addEventListener('click', function (event) {
    var label = event.target && event.target.closest && event.target.closest('.g-variant-color-detail label.swatch-anchor, fieldset.product-form__input label, .product-form__input label');
    var input = label && label.htmlFor && document.getElementById(label.htmlFor);
    if (input) setTimeout(function () { focusVariantImage(input); }, 80);
    setTimeout(run, 20);
    setTimeout(paintSwatches, 180);
    setTimeout(paintCardSwatches, 180);
  }, true);
  document.addEventListener('change', function (event) {
    if (event.target && event.target.matches('.g-variant-color-detail input[type="radio"], .product-form__input input[type="radio"]')) focusVariantImage(event.target);
    setTimeout(paintSwatches, 20);
    setTimeout(paintCardSwatches, 20);
  }, true);
  [100, 350, 900, 1800, 3500, 6500, 10000].forEach(function (ms) { setTimeout(run, ms); });
  new MutationObserver(function (mutations) {
    if (mutations.some(function (m) { return (m.addedNodes && m.addedNodes.length) || m.type === 'characterData'; })) requestAnimationFrame(run);
  }).observe(document.body || document.documentElement, { childList: true, subtree: true, characterData: true });
})();
